/* Stitchi Studio · ss-core.js
   Gedeelde hulpfuncties (uit de preview: site.js SS.*): panelen openen/sluiten met focusbeheer, geld, opslag, toast, live-regio,
   leverformule en deadlines (uit thema-instellingen), optiewaarden netjes tonen (SS.optLabel).
   Instellingen komen uit <script id="ss-inst" type="application/json"> in layout/theme.liquid. Geen bedragen hardcoded. */
(function () {
  'use strict';
  var SS = window.SS = window.SS || {};
  var INST = {};
  try { INST = JSON.parse((document.getElementById('ss-inst') || {}).textContent || '{}'); } catch (e) { INST = {}; }
  SS.INST = INST;
  /* meetpunt (1-11): v8-bezoekers filterbaar in Clarity (tag thema=v8); de embed laadt soms later dan dit script */
  (function clarityTag(n) { if (typeof window.clarity === 'function') { try { window.clarity('set', 'thema', 'v8'); } catch (e) {} } else if (n > 0) setTimeout(function () { clarityTag(n - 1); }, 1000); })(15);

  /* ---------- teksten uit de locales (vertaalronde) ----------
     Aanroep: SS.t + (sleutel 'groep.naam', Nederlandse tekst met {var}, { var: waarde }); ook (sleutel, {var}, nl) mag.
     Bron: JSON-blokken #ss-teksten-js (snippets/ss-teksten-js.liquid, via ss-inst) en #ss-teksten-cfg (configurator).
     Ontbreekt een sleutel, dan de Nederlandse tekst uit de code: NL breekt nooit. {var} wordt ingevuld; sleutels zonder _html
     worden ontdaan van door Shopify ge-escapete tekens (de scripts escapen zelf waar nodig). */
  var TX = null, ENT = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&#x27;': "'", '&#039;': "'" };
  function laadTX() {
    var t = {};
    ['ss-teksten-js', 'ss-teksten-cfg'].forEach(function (id) { var e = document.getElementById(id); if (!e) return; try { var d = JSON.parse(e.textContent || '{}'); for (var k in d) t[k] = d[k]; } catch (x) {} });
    if (document.readyState !== 'loading') TX = t;
    return t;
  }
  SS.t = function (k, a, b) {
    var nl = typeof a === 'string' ? a : b, vars = typeof a === 'string' ? b : a, s = (TX || laadTX())[k];
    if (typeof s !== 'string' || !s || /translation missing/i.test(s)) s = nl != null ? String(nl) : k;
    else if (!/_html$/.test(k)) s = s.replace(/&(?:amp|lt|gt|quot|#39|#x27|#039);/g, function (m) { return ENT[m]; });
    if (vars) s = s.replace(/\{(\w+)\}/g, function (m, n) { return vars[n] != null ? String(vars[n]) : m; });
    return s;
  };
  /* datums in de taal van de bezoeker: NL exact als voorheen (nl-NL), anders taal-land (bv. de-DE, fr-BE), terugval de taal */
  SS.taal = String(INST.taal || 'nl').toLowerCase();
  SS.datumLocale = (function () {
    var t = SS.taal, l = String(INST.land || '').toUpperCase();
    if (/^nl(\b|-)/.test(t)) return 'nl-NL';
    var kand = t.indexOf('-') > -1 ? t : (l ? t + '-' + l : t);
    try { if (typeof Intl !== 'undefined' && Intl.DateTimeFormat.supportedLocalesOf([kand]).length) return kand; } catch (e) {}
    return t.split('-')[0] || 'nl-NL';
  })();

  /* ---------- kleine hulpjes ---------- */
  SS.$ = function (s, el) { return (el || document).querySelector(s); };
  SS.$$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  SS.esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  SS.qs = function (k) { try { return new URLSearchParams(location.search).get(k); } catch (e) { return null; } };
  SS.store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } },
    weg: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };
  SS.hash = function (s) { var h = 2166136261; s = String(s); for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0).toString(36); };
  SS.uniek = function (pre) { return (pre || 'r') + Date.now().toString(36) + Math.floor(Math.random() * 1e6).toString(36); };
  /* fotoronde 21-10 (snelheid): beelden met data-ss-lazy (snippets/ss-beeld) krijgen hun bron pas binnen ±300 px van het scherm, en pas na 'load'.
     Ook voor later toegevoegde inhoud (templates, sectie-rendering) via een MutationObserver. */
  (function () {
    function laad(im) {
      var s = im.getAttribute('data-srcset'), u = im.getAttribute('data-src');
      if (s) { im.setAttribute('srcset', s); im.removeAttribute('data-srcset'); }
      if (u) { im.setAttribute('src', u); im.removeAttribute('data-src'); }
      im.removeAttribute('data-ss-lazy');
    }
    /* beelden in een horizontale scrollrij: de hele rij laadt zodra de rij zelf in de buurt komt (geen lege tegels bij swipen) */
    function rij(im) {
      for (var el = im.parentElement, i = 0; el && i < 6; el = el.parentElement, i++) {
        var ox = getComputedStyle(el).overflowX;
        if (ox === 'auto' || ox === 'scroll') return el;
      }
      return null;
    }
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        if (e.target.tagName === 'IMG') laad(e.target);
        else { e.target.__ssLazy = 2; Array.prototype.forEach.call(e.target.querySelectorAll('img[data-ss-lazy]'), laad); }
      });
    }, { rootMargin: '300px 0px' }) : null;
    function zoek(root) {
      if (!root || !root.querySelectorAll) return;
      var l = root.matches && root.matches('img[data-ss-lazy]') ? [root] : root.querySelectorAll('img[data-ss-lazy]');
      Array.prototype.forEach.call(l, function (im) {
        if (!io) { laad(im); return; }
        var r = rij(im);
        if (r) { if (r.__ssLazy === 2) laad(im); else if (!r.__ssLazy) { r.__ssLazy = 1; io.observe(r); } } else io.observe(im);
      });
    }
    SS.laadBeelden = zoek;
    function start() {
      zoek(document);
      if ('MutationObserver' in window) new MutationObserver(function (ms) { ms.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) zoek(n); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
      window.addEventListener('beforeprint', function () { Array.prototype.forEach.call(document.querySelectorAll('img[data-ss-lazy]'), laad); });
    }
    /* pas na 'load' (of bij de eerste scroll/aanraking/toets) gaan waarnemen: dan concurreren beelden onder de vouw niet met het LCP-beeld */
    var gestart = false;
    function eenmaal() { if (gestart) return; gestart = true; start(); }
    if (document.readyState === 'complete') eenmaal();
    else {
      window.addEventListener('load', eenmaal, { once: true });
      ['scroll', 'touchstart', 'keydown', 'wheel'].forEach(function (ev) { window.addEventListener(ev, eenmaal, { once: true, passive: true }); });
    }
  })();
  /* fotoronde 21-10: ontwerpbeelden ss-<naam>[-480|-960].jpg komen uit Shopify Files (INST.files = basis-URL), met breedte via de CDN */
  SS.asset = function (naam) {
    var m = /^ss-(.+?)(?:-(480|960))?\.jpg$/.exec(naam);
    if (m && INST.files) return INST.files + 'ss-' + m[1] + '.jpg?width=' + (m[2] || 960);
    return (INST.assets || '') + naam;
  };

  /* ---------- geld: altijd in centen uit Shopify; weergave volgens het geldformaat van de winkel/markt ---------- */
  function groep(n, dec, sep, punt) {
    var d = (n / 100).toFixed(dec).split('.');
    return d[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (d[1] ? punt + d[1] : '');
  }
  /* INST.geldVoorbeeld = {{ 123456 | money }} in de valuta van de bezoeker (markt), bijv. "€1.234,56" of "$1,234.56":
     daaruit lezen we teken, scheidingstekens en decimalen af, zodat JS hetzelfde formaat toont als Liquid. */
  var GV = (function () {
    var v = String(INST.geldVoorbeeld || '€1.234,56').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ');
    var m = /1([.,'’ ]?)234(?:([.,])56)?/.exec(v);
    /* valuta zonder decimalen (JPY): Shopify rondt af, "¥1,235" */
    var z = !m && /1([.,'’ ]?)235(?!\d)/.exec(v);
    if (z) return { voor: v.slice(0, z.index), na: v.slice(z.index + z[0].length), sep: z[1] || '', punt: '.', dec: 0 };
    if (!m) return { voor: '€', na: '', sep: '.', punt: ',', dec: 2 };
    return { voor: v.slice(0, m.index), na: v.slice(m.index + m[0].length), sep: m[1] || '', punt: m[2] || ',', dec: m[2] ? 2 : 0 };
  })();
  SS.geld = function (centen) {
    centen = Math.round(+centen || 0);
    var neg = centen < 0 ? '−' : '';
    return neg + GV.voor + groep(Math.abs(centen), GV.dec, GV.sep, GV.punt) + GV.na;
  };
  SS.fmt = function (euro) { return SS.geld(Math.round((+euro || 0) * 100)); };
  /* besluit 21-10: van-prijs (compare_at_price) doorgestreept, zelfde opbouw als snippets/ss-prijs.liquid.
     p, c in centen; o.vanaf = woord ervoor ("vanaf"), o.kaal = zonder omhullende .prijzen,
     o.bespaar = "je bespaart €…" erachter (alleen PDP; instelling bespaar_tonen) */
  SS.prijsHTML = function (p, c, o) {
    o = o || {}; var toon = !!INST.vanprijs && c > p, s = '';
    if (toon) s += '<s class="van"><span class="sr">' + (INST.tWas || 'Was') + ' </span>' + SS.geld(c) + '</s> ';
    s += '<span class="prijs">' + (toon ? '<span class="sr">' + (INST.tNu || 'nu') + ' </span>' : '') + (o.vanaf && INST.taal !== 'ja' ? o.vanaf + ' ' : '') + SS.geld(p) + (o.vanaf && INST.taal === 'ja' ? o.vanaf : '') + '</span>';
    if (toon && INST.kortingBadge) s += ' <span class="korting">−' + Math.floor((c - p) * 100 / c) + '%</span>';
    if (toon && INST.bespaar && o.bespaar) s += ' <span class="bespaar">' + SS.t('core.je_bespaart', 'je bespaart {bedrag}', { bedrag: SS.geld(c - p) }) + '</span>';
    return o.kaal ? s : '<span class="prijzen">' + s + '</span>';
  };

  /* ---------- optiewaarden netjes tonen (weergavelaag; de echte waarden blijven in het formulier) ---------- */
  SS.maat = function (w) { return String(w || '').replace(/(\d)\s*[x×]\s*(\d)/gi, '$1×$2'); };
  /* taalonafhankelijke herkenning (vertaalronde): optienamen en -waarden zijn per taal vertaald (Translate & Adapt).
     SS.isMaatWaarde: "30x40 cm" / "45 × 60 cm"; SS.niveau: kleurniveau uit het getal (20/30/40), terugval het woord tussen haakjes. */
  SS.isMaatWaarde = function (w) { return /^\s*\d+\s*[x×]\s*\d+\s*cm\b/i.test(String(w || '')); };
  SS.isNiveauWaarde = function (w) { return /\d+\s*\D{0,3}\s*[(（][^)）]*[)）]\s*$/.test(String(w || '')); };   /* ook ja: "最大20色（Essential）" */
  SS.niveau = function (w) {
    w = String(w || ''); var m = /(\d+)\s*\D{0,3}\s*[(（]/.exec(w), n = m ? +m[1] : 0;
    if (n === 20) return 'Essential'; if (n === 30) return 'Detailed'; if (n === 40) return 'Premium';
    var x = /[(（](essential|detailed|premium)[)）]/i.exec(w); return x ? x[1].charAt(0).toUpperCase() + x[1].slice(1).toLowerCase() : '';
  };
  /* rol (optioneel): 'maat' | 'kleuren' | 'type'; idx = index van de waarde in de optie (type: 0 = voorbedrukt, 1 = telpatroon) */
  SS.optLabel = function (naam, waarde, rol, idx) {
    var n = String(naam == null ? '' : naam).trim(), w = String(waarde == null ? '' : waarde).trim();
    if (!w || /^default title$/i.test(w) || /^title$/i.test(n)) return '';
    if (rol === 'maat' || /^(formaat|maat|afmeting)/i.test(n) || SS.isMaatWaarde(w)) return SS.maat(w);
    if (rol === 'kleuren' || /^aantal kleuren|^niveau|^kleuren$/i.test(n) || SS.isNiveauWaarde(w)) { var m = w.match(/(\d+)/); return m ? SS.t('core.tot_kleuren', 'Tot {n} kleuren', { n: m[1] }) : w.replace(/\s*[(（](essential|detailed|premium)[)）]/i, ''); }
    if (rol === 'type' || /^type$/i.test(n)) return /telpatroon/i.test(w) ? SS.t('core.telpatroon', 'telpatroon') : /voorbedrukt/i.test(w) ? SS.t('core.voorbedrukt', 'voorbedrukt') : /^canvas$/i.test(w) ? w.toLowerCase() : idx === 1 ? SS.t('core.telpatroon', 'telpatroon') : idx === 0 ? SS.t('core.voorbedrukt', 'voorbedrukt') : /^nl/.test(SS.taal || 'nl') ? w.toLowerCase() : w;
    if (/^(stof|canvas)$/i.test(n)) return w.toUpperCase().replace(/\s+/g, '');
    if (/^foto$/i.test(n)) return '';
    if (/^opmerking$/i.test(n) && /foto volgt/i.test(w)) return SS.t('core.foto_volgt_later', 'foto volgt later');
    if (/^bedrag$/i.test(n)) return w;
    return n + ': ' + w;
  };
  /* één optiewaarde zonder optienaam (knoppen, keuzeregel): "Voorbedrukt Canvas" → "Voorbedrukt", "30x40 cm" → "30×40 cm" */
  SS.optWaarde = function (naam, waarde, rol, idx) {
    var l = SS.optLabel(naam, waarde, rol, idx);
    if ((rol === 'type' || /^type$/i.test(naam)) && l) return l.charAt(0).toUpperCase() + l.slice(1);
    return l;
  };

  /* ---------- toast en live-regio ---------- */
  SS.live = function (msg) {
    var r = document.getElementById('ss-live');
    if (!r && document.body) { r = document.createElement('div'); r.id = 'ss-live'; r.className = 'sr'; r.setAttribute('role', 'status'); r.setAttribute('aria-live', 'polite'); document.body.appendChild(r); }
    if (r && msg != null) { r.textContent = ''; setTimeout(function () { r.textContent = msg; }, 60); }
  };
  SS.toast = function (msg, ms) {
    var t = SS.$('.toast'); if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('aria-hidden', 'true'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('toon'); clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('toon'); }, ms || 2600);
    SS.live(msg);
  };

  /* ---------- levering en deadlines (formule uit de preview; datums uit thema-instellingen) ---------- */
  SS.werkdagen = function (d, n) { d = new Date(d); var st = n < 0 ? -1 : 1; n = Math.abs(n); while (n > 0) { d.setDate(d.getDate() + st); if (d.getDay() % 6) n--; } return d; };
  SS.datumKort = function (d) { var s = new Date(d).toLocaleDateString(SS.datumLocale, { weekday: 'short', day: 'numeric', month: 'short' }); return SS.datumLocale === 'nl-NL' ? s.replace(/\./g, '') : s; };
  SS.datumLang = function (d) { return new Date(d).toLocaleDateString(SS.datumLocale, { weekday: 'long', day: 'numeric', month: 'long' }); };
  SS.leverVenster = function (vanaf) {
    var n = vanaf instanceof Date ? vanaf : new Date(), a = SS.werkdagen(n, 7), b = SS.werkdagen(n, 11);
    return { van: a, tot: b, tekst: SS.t('core.venster', '{van} – {tot}', { van: SS.datumKort(a), tot: SS.datumKort(b) }) };
  };
  function datum(s) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || '').trim()); return m ? new Date(+m[1], +m[2] - 1, +m[3], 12, 0, 0) : null; }
  /* Deadlines (preview SS.DEADLINES): datums uit de thema-instellingen; ontbreekt er een, dan dezelfde formule als de preview
     (laatste besteldag waarop de uiterste leverdatum, werkdag 11, vóór het feest valt). tekst/kort voor de aankondigingsbalk. */
  SS.DEADLINES = (function () {
    var nu = new Date(), jaar = nu.getFullYear(), dag = function (y, m, d) { return new Date(y, m, d, 12, 0, 0); };
    var v = dag(jaar, nu.getMonth(), nu.getDate());
    function uiterste(feest) { var d = new Date(feest); for (var i = 0; i < 60; i++) { d.setDate(d.getDate() - 1); if (SS.werkdagen(d, 11) < feest) return d; } return null; }
    var r = { sinterklaas: datum(INST.deadlineSint), kerst: datum(INST.deadlineKerst), vanaf: datum(INST.deadlineVanaf), naDeadline: false };
    var kj = r.kerst ? r.kerst.getFullYear() : jaar, feestK = dag(kj, 11, 24), feestS = dag(kj, 11, 5);
    if (!r.sinterklaas) r.sinterklaas = uiterste(feestS);
    if (!r.kerst) r.kerst = uiterste(feestK);
    if (!r.vanaf) r.vanaf = dag(kj, 9, 1);
    r.actief = !!(r.sinterklaas && r.kerst && v >= r.vanaf && v < feestK) && String(INST.land || '').toUpperCase() !== 'JP';   /* Japan: geen NL-deadlines */
    var lang = SS.datumLang;
    if (v <= r.sinterklaas) { r.tekst = SS.t('core.dl_sint', 'Op tijd voor Sinterklaas: bestel uiterlijk {sint}. Voor Kerst: uiterlijk {kerst} (indicatie)', { sint: lang(r.sinterklaas), kerst: lang(r.kerst) }); r.kort = SS.t('core.dl_sint_kort', 'Sinterklaas: bestel uiterlijk {datum}', { datum: SS.datumKort(r.sinterklaas) }); }
    else if (v <= r.kerst) { r.tekst = SS.t('core.dl_kerst', 'Op tijd voor Kerst: bestel uiterlijk {datum} (indicatie)', { datum: lang(r.kerst) }); r.kort = SS.t('core.dl_kerst_kort', 'Kerst: bestel uiterlijk {datum}', { datum: SS.datumKort(r.kerst) }); }
    else { r.naDeadline = true; r.tekst = SS.t('core.dl_te_laat', 'Een pakket redden we niet meer voor Kerst. Een cadeaubon kan nog wel'); r.kort = SS.t('core.dl_te_laat_kort', 'Voor Kerst: geef een cadeaubon'); }
    return r;
  })();
  SS.deadlineRegel = function (heeftPakket) {
    var D = SS.DEADLINES; if (!D.actief || !heeftPakket) return null;
    var n = new Date(), v = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 12, 0, 0);
    if (v <= D.sinterklaas) return { ok: true, kort: SS.t('core.op_tijd_sint', 'op tijd voor Sinterklaas'), tekst: SS.t('core.vandaag_sint', 'Vandaag besteld: op tijd voor Sinterklaas (indicatie)') };
    if (v <= D.kerst) return { ok: true, kort: SS.t('core.op_tijd_kerst', 'op tijd voor Kerst'), tekst: SS.t('core.vandaag_kerst', 'Vandaag besteld: op tijd voor Kerst (indicatie)') };
    return { ok: false, tekst: SS.t('core.dl_te_laat', 'Een pakket redden we niet meer voor Kerst. Een cadeaubon kan nog wel'), link: INST.cadeaubonUrl || '/products/cadeaubon' };
  };
  SS.deadlineRegelHTML = function (heeftPakket, klas) {
    var d = SS.deadlineRegel(heeftPakket); if (!d) return '';
    return '<p class="dl-regel' + (d.ok ? ' ok' : ' te-laat') + (klas ? ' ' + klas : '') + '">' + (d.ok ? '<span class="dl-vink" aria-hidden="true">✓</span>' : '') + '<span>' + SS.esc(d.tekst) + (d.link ? ' · <a class="link" href="' + SS.esc(d.link) + '">' + SS.esc(SS.t('core.geef_bon', 'Geef een cadeaubon')) + '</a>' : '') + '</span></p>';
  };
  SS.ICON = {
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>',
    tas: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    x: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>'
  };
  SS.leverRegelHTML = function (heeftPakket, klas) {
    if (!heeftPakket) return '';
    var lev = SS.leverVenster(), d = SS.deadlineRegel(true);
    return '<p class="' + (klas || 'lever-regel') + '">' + SS.ICON.truck + '<span>' + SS.t('core.lever_vandaag_html', 'Vandaag besteld, verwacht <b>{venster}</b>', { venster: lev.tekst }) + (d && d.ok ? '<span class="dl-kort"> · ' + d.kort + ' <span class="dl-vink" aria-hidden="true">✓</span></span>' : '') + '</span></p>' + (d && !d.ok ? SS.deadlineRegelHTML(true) : '');
  };

  /* ---------- panelen: lade, zoeken, mobiel menu (focus erin, Tab blijft binnen, Esc sluit, focus terug; dicht = inert) ---------- */
  var openEl = null, terugEl = null;
  SS.focusbaar = function (el) {
    return SS.$$('a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])', el).filter(function (x) {
      return !x.disabled && x.getClientRects().length && !(x.closest && x.closest('[inert]'));
    });
  };
  SS.trap = function (el) {
    if (!el || el._trap) return; el._trap = true;
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = SS.focusbaar(el); if (!f.length) { e.preventDefault(); return; }
      var a = f[0], z = f[f.length - 1], act = document.activeElement;
      if (e.shiftKey && (act === a || !el.contains(act))) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && (act === z || !el.contains(act))) { e.preventDefault(); a.focus(); }
    });
  };
  /* preview fase 6: de filters van de collectie (.bb-filters) zijn alleen tot 900 px een lade; daarboven gewoon bruikbaar */
  SS.zetInert = function () {
    var smal = window.matchMedia ? matchMedia('(max-width: 900px)').matches : true;
    SS.$$('.lade, .zoek-paneel').forEach(function (el) {
      var lade = !el.classList.contains('bb-filters') || smal, dicht = lade && !el.classList.contains('open');
      el.inert = dicht; if (dicht) el.setAttribute('aria-hidden', 'true'); else el.removeAttribute('aria-hidden');
    });
  };
  SS.close = function (stil) {
    var was = openEl;
    SS.$$('.lade.open, .zoek-paneel.open').forEach(function (e) { e.classList.remove('open'); });
    var s = document.getElementById('scherm'); if (s) s.classList.remove('open');
    document.body.style.overflow = ''; openEl = null; SS.zetInert();
    if (stil !== true && was && terugEl && document.contains(terugEl)) terugEl.focus();
    if (stil !== true) terugEl = null;
  };
  SS.open = function (id) {
    var vorig = document.activeElement; SS.close(true);
    var el = document.getElementById(id); if (!el) return false;
    el.classList.add('open'); openEl = el; terugEl = vorig && vorig !== document.body ? vorig : null;
    SS.zetInert(); SS.trap(el);
    if (id !== 'zoek') { var s = document.getElementById('scherm'); if (s) s.classList.add('open'); }
    document.body.style.overflow = id === 'zoek' ? '' : 'hidden';
    if (id === 'winkelwagen' && SS.lade) SS.lade.render();
    try { document.dispatchEvent(new CustomEvent('ss:open', { detail: { id: id } })); } catch (e) {}
    var veld = el.querySelector('input[type="search"]') || el.querySelector('.lade-kop [data-sluit]') || SS.focusbaar(el)[0];
    if (veld) setTimeout(function () { if (el.classList.contains('open')) veld.focus(); }, 60);
    return true;
  };
  /* preview Q28: is er iets anders open (configurator, lade, menu, zoeken, formaatgids, lightbox)? Dan geen pop-up. */
  SS.bezig = function () {
    return document.documentElement.classList.contains('cfg-lock') || !!(window.SSConfigurator && SSConfigurator.isOpen && SSConfigurator.isOpen()) ||
      !!SS.$('.lade.open, .zoek-paneel.open, .modal.open, .lb.open, [role="dialog"][aria-modal="true"]:not([hidden]):not(#welkom):not(.lade):not(.zoek-paneel):not([inert])') || document.body.style.overflow === 'hidden';
  };
  SS.openCart = function () { if (!SS.open('winkelwagen')) location.href = INST.cartUrl || '/cart'; };
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentNode;
    var o = t.closest('[data-open]');
    if (o) { if (document.getElementById(o.getAttribute('data-open'))) { e.preventDefault(); SS.open(o.getAttribute('data-open')); } return; }
    if (t.closest('[data-sluit]') || t.id === 'scherm') { e.preventDefault(); SS.close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openEl) SS.close(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', SS.zetInert); else SS.zetInert();

  /* Contactformulier: kom je na het versturen (doorverwijzing) op een andere pagina uit, dan terug naar de melding "bericht verstuurd" */
  try {
    var cl = JSON.parse(sessionStorage.getItem('ss_contact_laatst') || 'null');
    if (cl && cl.t && Date.now() - cl.t < 120000 && !document.querySelector('[data-ss-contact]') && !/\/challenge/.test(location.pathname)) {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (/[?&]contact_posted=true/.test(location.search) || (nav && nav.redirectCount > 0 && (!document.referrer || /contact|challenge/.test(document.referrer)))) {
        location.replace(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/contact?verstuurd=1');
      }
    }
  } catch (e) {}
})();
